import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'


const _hoisted_1 = { class: "px-5 pt-3 pb-2 mb-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "items-center justify-between flex" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center w-2/4"
}
const _hoisted_5 = {
  key: 1,
  class: "title flex items-center"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 0,
  class: "flex"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_15 = { class: "w-full h-auto bg-white p-4 border border-lightgrey mt-5 rounded-sm" }
const _hoisted_16 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_17 = {
  key: 0,
  class: "error-text"
}
const _hoisted_18 = { class: "upperspacing" }
const _hoisted_19 = { class: "mt-3" }
const _hoisted_20 = { style: {"margin-top":"-6px !important"} }
const _hoisted_21 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.checkCreateOrEdit())
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.titleLength > 40? 'table-ellipsis':'')
              }, _toDisplayString(_ctx.presentTemplateObject.title), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("h1", null, "Create a template", -1)
            ]))])),
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.editPage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["mr-1.5", (JSON.stringify(_ctx.addTemplateObjectDummy) == JSON.stringify(_ctx.addTemplateObject)) && _ctx.addedControlArray == '' ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickCanelBtn()))
                }, "Reset", 10, _hoisted_8),
                _createElementVNode("button", {
                  class: _normalizeClass(["", (JSON.stringify(_ctx.addTemplateObjectDummy) == JSON.stringify(_ctx.addTemplateObject)) && _ctx.addedControlArray == '' ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickSaveBtn()))
                }, "Save", 10, _hoisted_9)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["mr-1.5", (_ctx.areControlIdsSame()&& ((_ctx.presentTemplateObjectDummy === _ctx.addTemplateObject.template)) )|| ((_ctx.areControlIdsSame())&&_ctx.controlIdsArray.length == 0 &&(_ctx.presentTemplateObjectDummy == _ctx.addTemplateObject.template))? 'btndisabled pointer-events-none ' : 'btnprimary']),
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickCanelBtnForupdate()))
                }, "Reset", 10, _hoisted_11),
                _createElementVNode("button", {
                  class: _normalizeClass(["", (_ctx.areControlIdsSame()&& ((_ctx.presentTemplateObjectDummy === _ctx.addTemplateObject.template)) )|| ((_ctx.areControlIdsSame())&&_ctx.controlIdsArray.length == 0 &&(_ctx.presentTemplateObjectDummy == _ctx.addTemplateObject.template)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                  disabled: _ctx.clickOnButton,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickUpdateBtn()))
                }, "Update", 10, _hoisted_12)
              ])),
          _createElementVNode("button", {
            class: _normalizeClass(["ml-1.5 flex", _ctx.addedControlArray.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton']),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.addedControlArray.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14)),
            _cache[8] || (_cache[8] = _createTextVNode(" Filters ", -1))
          ], 2)
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-3" }, [
        _createElementVNode("p", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "controllabel text-xs" }, "Template", -1)),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.addTemplateObject.template.$error }]),
              type: "text",
              placeholder: "Template Name",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addTemplateObject.template) = $event))
            }, null, 2), [
              [
                _vModelText,
                _ctx.addTemplateObject.template,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.v$.addTemplateObject.template.$error )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.v$.addTemplateObject.template.required.$invalid )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Required"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "controllabel text-xs" }, "Control", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_AutoComplete, {
                modelValue: _ctx.addTemplateObject.selectedControlNumber,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addTemplateObject.selectedControlNumber) = $event)),
                suggestions: _ctx.controlOptions,
                onComplete: _ctx.asyncFind,
                onItemSelect: _ctx.onSelectingControlNumberBtn,
                optionLabel: "label",
                optionValue: "value",
                placeholder: "Control",
                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
                                    'has-options': _ctx.controlOptions && _ctx.controlOptions.length > 0,
                                    'no-options': !_ctx.controlOptions.length &&  _ctx.searchValue !== '',
                                }])
              }, {
                empty: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("div", { class: "text-sm" }, [
                    _createElementVNode("span", null, "No Control Found")
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "class"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pb-1 font-semibold border-b border-lightgrey" }, "Controls", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_tableData, {
              tableRowData: _ctx.addedControlArray,
              headersData: _ctx.headers
            }, null, 8, ["tableRowData", "headersData"]),
            (_ctx.toolTipActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}